window.addEventListener("load", function () {
    new Swiper(".swiper-feature", {
        effect: "coverflow",
        centeredSlides: true,
        slidesPerView: 1,
        loop: true,
          pagination: {
        el: ".swiper-feature-banner-pagination",
        clickable: true,
        enabled: true,
      },
        breakpoints: {
            769: {
                slidesPerView: 3,
            },
        },
        coverflowEffect: {
            rotate: 0,      // góc xoay
            stretch: 100,      // kéo giãn giữa các slide
            depth: 100,      // độ sâu 3D
            modifier: 2,     // độ mạnh hiệu ứng
            slideShadows: true, // bóng mờ
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});